export default __webpack_public_path__ + "static/media/Blade's Arm-straps of Charred Earth.3edd6d0b.jpg";